<template>
  <div>
    <!--
      AV 12 — "possuir inteligência artificial com aprendizado contínuo a partir dos
      atendimentos disponibilizados".

      Esta é a tela da CURADORIA. Ela existe para que o ciclo do requisito seja executável por
      uma pessoa avaliadora, sem SQL e sem Postman:

          fila (vinda dos atendimentos) → aprovar apontando o nó → publicar versão N+1

      Nenhuma regra de negócio mora aqui. Quem decide o que pode ser publicado, quem pode
      publicar e o que entra na versão é o backend — esta tela mostra e pede.
    -->

    <el-form :inline="true" size="small" class="u-mb-10">
      <el-form-item label="Fluxo">
        <el-select v-model="fluxoId" placeholder="selecione" style="width:260px" @change="carregar">
          <el-option v-for="f in fluxos" :key="f.id" :label="f.nome" :value="f.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Situação">
        <el-select v-model="status" clearable placeholder="todas" style="width:150px" @change="carregarFila">
          <el-option label="pendente" value="pendente"></el-option>
          <el-option label="aprovado" value="aprovado"></el-option>
          <el-option label="rejeitado" value="rejeitado"></el-option>
          <el-option label="duplicado" value="duplicado"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="fas fa-sync" @click="carregar" :loading="carregando">
          Atualizar
        </el-button>
      </el-form-item>
    </el-form>

    <el-alert v-if="erro" type="error" :closable="false" show-icon data-test="erro" :title="erro"
              class="u-mb-10"></el-alert>

    <div v-if="!fluxoId" class="obs" data-test="sem-fluxo">
      Selecione um fluxo de atendimento para ver a fila de curadoria.
    </div>

    <template v-else>
      <!-- ============ situação do conhecimento ============ -->
      <el-row :gutter="10" class="u-mb-10">
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">na fila</div>
          <div class="val" data-test="qtd-pendentes">{{ (painel.fila && painel.fila.pendente) || 0 }}</div>
          <div class="obs">aguardando curadoria</div>
        </div></el-col>
        <el-col :xs="12" :sm="6"><div class="cartao destaque">
          <div class="rot">versão vigente</div>
          <div class="val" data-test="versao-vigente">
            {{ painel.versao_ativa ? painel.versao_ativa.versao : '—' }}
          </div>
          <div class="obs">
            {{ painel.versao_ativa ? painel.versao_ativa.total_exemplos + ' exemplo(s)'
                                   : 'nenhum conhecimento publicado' }}
          </div>
        </div></el-col>
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">aprovados a publicar</div>
          <div class="val" data-test="qtd-aprovados">{{ (painel.fila && painel.fila.aprovado) || 0 }}</div>
          <div class="obs">só passam a valer após publicar</div>
        </div></el-col>
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">tempo médio de curadoria</div>
          <div class="val" data-test="tempo-curadoria">
            {{ painel.tempo_medio_curadoria_h === null || painel.tempo_medio_curadoria_h === undefined
               ? '—' : painel.tempo_medio_curadoria_h + 'h' }}
          </div>
        </div></el-col>
      </el-row>

      <!--
        O aviso existe porque a confusão é previsível: aprovar NÃO muda o atendimento.
        Sem publicar, o curador aprova dez itens, testa, não vê diferença e conclui que o
        sistema está quebrado.
      -->
      <el-alert v-if="(painel.fila && painel.fila.aprovado) > 0" type="warning" :closable="false"
                show-icon data-test="aviso-publicar" class="u-mb-10"
                title="Há conhecimento aprovado que ainda não está valendo.">
        <div class="obs">
          Aprovar registra a decisão; o assistente só muda de comportamento quando a versão
          é publicada.
        </div>
      </el-alert>

      <el-row :gutter="10">
        <!-- ============ fila de curadoria ============ -->
        <el-col :xs="24" :sm="14">
          <c-panel title="Fila de curadoria (vinda dos atendimentos)" titleIcon="fas fa-inbox">
            <table class="table table-striped" data-test="fila">
              <thead>
                <tr>
                  <th>O que o cidadão escreveu</th>
                  <th style="width:70px">vezes</th>
                  <th style="width:110px">situação</th>
                  <th style="width:230px">ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in itens" :key="i.id" :data-test="'item-' + i.id">
                  <td>
                    {{ i.pergunta }}
                    <div class="obs">
                      origem: {{ i.origem }}
                      <span v-if="i.no_correto">· destino: {{ i.no_correto }}</span>
                      <span v-if="i.versao_publicada">· publicado na v{{ i.versao_publicada }}</span>
                      <span v-if="i.curado_por">· curado por {{ i.curado_por }}</span>
                    </div>
                  </td>
                  <td>{{ i.ocorrencias }}</td>
                  <td><span :class="'sit sit-' + i.status">{{ i.status }}</span></td>
                  <td>
                    <template v-if="i.status === 'pendente'">
                      <el-select v-model="destino[i.id]" size="mini" placeholder="nó de destino"
                                 style="width:130px" :data-test="'destino-' + i.id">
                        <el-option v-for="n in nos" :key="n.id" :label="n.chave" :value="n.id"></el-option>
                      </el-select>
                      <el-button size="mini" type="success" :data-test="'aprovar-' + i.id"
                                 :disabled="!destino[i.id] || salvando"
                                 @click="curar(i, 'aprovado')">aprovar</el-button>
                      <el-button class="u-ml-10" size="mini" type="danger" :data-test="'rejeitar-' + i.id"
                                 :disabled="salvando" @click="curar(i, 'rejeitado')">rejeitar</el-button>
                    </template>
                    <span v-else class="obs">—</span>
                  </td>
                </tr>
                <tr v-if="!itens.length">
                  <td colspan="4" class="obs" data-test="fila-vazia">
                    Nada na fila. Ela é alimentada pelos atendimentos: quando o assistente não
                    entende o que o cidadão escreveu, a formulação aparece aqui.
                  </td>
                </tr>
              </tbody>
            </table>
          </c-panel>
        </el-col>

        <!-- ============ versões ============ -->
        <el-col :xs="24" :sm="10">
          <c-panel title="Versões do conhecimento" titleIcon="fas fa-code-branch">
            <div class="u-mb-10">
              <el-input v-model="resumo" size="mini" placeholder="resumo da mudança (opcional)"
                        data-test="resumo" style="width:100%"></el-input>
            </div>
            <el-button type="primary" size="small" icon="fas fa-upload" data-test="publicar"
                       :loading="publicando" @click="publicar">
              Publicar versão {{ proximaVersao }}
            </el-button>

            <table class="table table-striped u-mt-10" data-test="versoes">
              <thead>
                <tr>
                  <th style="width:50px">v</th>
                  <th>publicada</th>
                  <th style="width:70px">itens</th>
                  <th style="width:110px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="v in painel.versoes" :key="v.id" :data-test="'versao-' + v.versao">
                  <td>
                    {{ v.versao }}
                    <i v-if="v.ativa" class="fas fa-check-circle" title="vigente"></i>
                  </td>
                  <td>
                    {{ v.publicada_em }}
                    <div class="obs" v-if="v.resumo_mudanca">{{ v.resumo_mudanca }}</div>
                    <div class="obs" v-if="v.motivo_desativacao">
                      desativada: {{ v.motivo_desativacao }}
                    </div>
                  </td>
                  <td>{{ v.total_exemplos }}</td>
                  <td>
                    <el-button size="mini" :data-test="'ver-' + v.versao" @click="verVersao(v.versao)">
                      ver
                    </el-button>
                    <el-button class="u-ml-10" v-if="!v.ativa" size="mini" type="warning"
                               :data-test="'reverter-' + v.versao" :disabled="salvando"
                               @click="reverter(v.versao)">reverter</el-button>
                  </td>
                </tr>
                <tr v-if="!painel.versoes || !painel.versoes.length">
                  <td colspan="4" class="obs" data-test="sem-versoes">
                    Nenhuma versão publicada. O assistente responde só pelo menu.
                  </td>
                </tr>
              </tbody>
            </table>
          </c-panel>
        </el-col>
      </el-row>

      <!-- ============ conteúdo de uma versão ============ -->
      <c-panel v-if="versaoAberta" :title="'Conteúdo congelado da versão ' + versaoAberta.versao.versao"
               titleIcon="fas fa-lock" class="u-mt-10">
        <div class="obs u-mb-10">
          Este conteúdo não muda quando novas versões são publicadas — é o que permite explicar,
          depois, com qual conhecimento um atendimento foi respondido.
        </div>
        <table class="table table-striped" data-test="itens-versao">
          <tr v-for="i in versaoAberta.itens" :key="i.id">
            <td>{{ i.pergunta }}</td>
            <td style="width:150px">→ {{ i.no_destino }}</td>
          </tr>
        </table>
      </c-panel>
    </template>
  </div>
</template>

<script>
import assistenteApi from '../assistenteApi'

export default {
  name: 'AssistenteAprendizado',

  data () {
    return {
      api: null,
      fluxos: [],
      nos: [],
      fluxoId: null,
      status: 'pendente',
      itens: [],
      painel: {},
      destino: {},
      resumo: '',
      versaoAberta: null,
      carregando: false,
      salvando: false,
      publicando: false,
      erro: null
    }
  },

  computed: {
    proximaVersao () {
      const vs = this.painel.versoes || []
      return vs.length ? Math.max.apply(null, vs.map(function (v) { return v.versao })) + 1 : 1
    }
  },

  mounted () {
    this.api = assistenteApi.criar({ axios: this.$axios, base: this.base(), auth: this.auth() })
    this.carregarFluxos()
  },

  methods: {
    base () { return this.$store.state.config.baseUrlApi },
    auth () { return this.$store.getters.getHeaderAuth },

    /* O backend nega permissão com HTTP 200 + {erro:{cod:800}}, não com 403. */
    textoErro (e) {
      const r = e && e.response ? e.response : null
      if (!r) return 'Falha de comunicação com o servidor.'
      if (r.data && typeof r.data.erro === 'string') return r.data.erro
      if (r.data && r.data.erro && r.data.erro.text) return r.data.erro.text
      if (r.status === 409) return 'Outra publicação ocorreu ao mesmo tempo. Atualize e tente de novo.'
      return 'Erro ' + r.status + ' ao consultar o servidor.'
    },

    carregarFluxos () {
      const self = this
      this.api.fluxos().then(function (r) {
        self.fluxos = (r.data && r.data.fluxos) || r.data || []
        if (self.fluxos.length && !self.fluxoId) {
          self.fluxoId = self.fluxos[0].id
          self.carregar()
        }
      }).catch(function (e) { self.erro = self.textoErro(e) })
    },

    carregar () {
      if (!this.fluxoId) return
      this.versaoAberta = null
      this.carregarNos()
      this.carregarFila()
      this.carregarPainel()
    },

    carregarNos () {
      const self = this
      this.api.arvore(this.fluxoId).then(function (r) {
        self.nos = (r.data && r.data.nos) || []
      }).catch(function (e) { self.erro = self.textoErro(e) })
    },

    carregarFila () {
      if (!this.fluxoId) return
      const self = this
      this.carregando = true
      this.erro = null
      this.api.aprendizadoFila(this.fluxoId, { status: this.status }).then(function (r) {
        self.itens = (r.data && r.data.itens) || []
        self.carregando = false
      }).catch(function (e) {
        self.erro = self.textoErro(e)
        self.itens = []
        self.carregando = false
      })
    },

    carregarPainel () {
      const self = this
      this.api.aprendizadoPainel(this.fluxoId).then(function (r) {
        self.painel = r.data || {}
      }).catch(function (e) { self.erro = self.textoErro(e) })
    },

    curar (item, status) {
      if (this.salvando) return
      const self = this
      this.salvando = true
      this.erro = null

      this.api.aprendizadoCurar(item.id, {
        status: status,
        no_correto_id: status === 'aprovado' ? this.destino[item.id] : null
      }).then(function () {
        window.eventBus.$emit('alert', {
          msg: status === 'aprovado'
            ? 'Aprovado. Publique a versão para que passe a valer.'
            : 'Registro rejeitado.',
          type: 'success'
        })
        self.salvando = false
        self.carregar()
      }).catch(function (e) {
        self.erro = self.textoErro(e)
        self.salvando = false
      })
    },

    publicar () {
      if (this.publicando) return
      const self = this
      this.publicando = true
      this.erro = null

      this.api.aprendizadoPublicar(this.fluxoId, this.resumo).then(function (r) {
        window.eventBus.$emit('alert', {
          msg: 'Versão ' + r.data.versao + ' publicada com ' + r.data.total_exemplos + ' exemplo(s).',
          type: 'success'
        })
        self.resumo = ''
        self.publicando = false
        self.carregar()
      }).catch(function (e) {
        self.erro = self.textoErro(e)
        self.publicando = false
      })
    },

    verVersao (versao) {
      const self = this
      this.api.aprendizadoVersao(this.fluxoId, versao).then(function (r) {
        self.versaoAberta = r.data
      }).catch(function (e) { self.erro = self.textoErro(e) })
    },

    reverter (versao) {
      if (this.salvando) return
      const self = this
      this.salvando = true
      this.erro = null

      this.api.aprendizadoReverter(this.fluxoId, versao, 'reversão pela tela de curadoria')
        .then(function () {
          window.eventBus.$emit('alert', { msg: 'Versão ' + versao + ' voltou a vigorar.', type: 'success' })
          self.salvando = false
          self.carregar()
        }).catch(function (e) {
          self.erro = self.textoErro(e)
          self.salvando = false
        })
    }
  }
}
</script>

<style scoped>
.cartao { border: 1px solid #ebeef5; border-radius: 4px; padding: 10px; }
.cartao.destaque { border-color: #409eff; }
.rot { font-size: 11px; color: #909399; text-transform: uppercase; }
.val { font-size: 22px; font-weight: 600; }
.obs { font-size: 11px; color: #909399; }
.sit { padding: 1px 6px; border-radius: 3px; font-size: 11px; }
.sit-pendente { background: #fdf6ec; color: #e6a23c; }
.sit-aprovado { background: #f0f9eb; color: #67c23a; }
.sit-rejeitado { background: #fef0f0; color: #f56c6c; }
.sit-duplicado { background: #f4f4f5; color: #909399; }
.u-mb-10 { margin-bottom: 10px; }
.u-mt-10 { margin-top: 10px; }
</style>
